// exclude-from-index
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StyledDrawer, DrawerContainer, DrawerContent } from './Drawer.styles';

class Drawer extends Component {
  static propTypes = {
    open: PropTypes.bool,
    children: PropTypes.node,
    contentStyleOverrides: PropTypes.string
  };

  static defaultProps = {
    open: true,
    children: null,
    contentStyleOverrides: ''
  };

  render() {
    const { open, children, contentStyleOverrides } = this.props;

    return (
      <DrawerContainer>
        <StyledDrawer anchor="left" overlay="hidden" open={open} variant="persistent">
          <DrawerContent className="DrawerContent" contentStyleOverrides={contentStyleOverrides}>
            {children}
          </DrawerContent>
        </StyledDrawer>
      </DrawerContainer>
    );
  }
}

export default Drawer;
